import { ILearnLink } from 'marketing-site/src/components/bespoke/resources/link'
export { LearnLinks } from './component-legacy'

export const LearnLinkLabels = {
  guide: 'Guide',
  book: 'Book',
  Demo: 'Demo',
  Article: 'Article',
  Guide: 'Guide',
  Page: 'Page',
  Podcast: 'Podcast',
  Video: 'Video',
  'Customer story': 'Customer story',
} as const

export type ILinkLabelKey = keyof typeof LearnLinkLabels
export type ILinkLabel = typeof LearnLinkLabels[ILinkLabelKey]

export const getLabelByKey = (key?: ILinkLabelKey): ILinkLabel => {
  return LearnLinkLabels[key ?? LearnLinkLabels.Article]
}

export interface IProps {
  headline: string | undefined
  ctaUrl?: string | undefined
  viewAll?: string | undefined
  appearance?: 'Large Cards' | 'Small Cards' | 'Embedded'
  background: string
  links: (ILearnLink | null)[] | undefined
  asFullGrid?: boolean
}
